import { Link, Modal, Spinner } from '@amzn/awsui-components-react-v3';
import React, { useState } from 'react';


export const getConfigurableLink  = (item: DDBRow) => {

  
  const [visible, setVisible] = useState(false);

    const handleClick = () => {
      setVisible(!visible);
    }

    return <div><Link variant="secondary" onFollow={ () => { handleClick}}>
            {item.ResourceName}
          </Link>
          <Modal
          onDismiss={() => {handleClick}}
          visible={visible}
          header={<span className="flashbar_header"><Spinner size="big"></Spinner>Saving </span>}
          footer={<span className="awsui-util-f-r"></span>}
          >
            Saving the Entity Details for . Please wait!
          </Modal>
          </div>
}

export const resourceColumnDefinition  : any = (resourceType) => {
  switch(resourceType) {
    case AWS_RESOURCE_TYPE.SNS.type:
      return SNSColumnDefination;
    case AWS_RESOURCE_TYPE.SQS.type:
      return SNSColumnDefination;
    case AWS_RESOURCE_TYPE.KMS.type:
      return KMSColumnDefinition;
    case AWS_RESOURCE_TYPE.DYNAMO_DB.type:
      return DDBColumnDefination;
    case AWS_RESOURCE_TYPE.IAM_POLICY.type:
      return SNSColumnDefination;
    case AWS_RESOURCE_TYPE.IAM_USER.type:
      return SNSColumnDefination;
    case AWS_RESOURCE_TYPE.IAM_ROLE.type:
      return SNSColumnDefination;
    case AWS_RESOURCE_TYPE.S3.type:
      return S3ColumnDefinition;
  }
}

const S3ColumnDefinition = [
  {
    id: "resourceName",
    header: "Resource Name",
    cell: item => item.ResourceName,
  },
  {
    id: "resourceArn",
    header: "Resource ID",
    cell: item => item.ResourceId,
  },
  {
    id: "newBucketName",
    header: "S3 Bucket Prefix",
    cell: item => item.ConfiguredProperties && item.ConfiguredProperties['BucketPrefix']

  }
]

export const SNSColumnDefination = [
    {
        id: "resourceName",
        header: "Resource Name",
        cell: item => item.ResourceName,
    },
    {
        id: "resourceId",
        header: "Resource ID",
        cell: item => item.ResourceId,
    }
]

export const KMSColumnDefinition = [
  {
      id: "aliases",
      header: "Alias",
      cell: item => item.CurrentProperties['Aliases'],
  },
  {
      id: "resourceArn",
      header: "Resource ID",
      cell: item => item.ResourceId,
  }
]

const DDBColumnDefination = [
  {
      id: "resourceName",
      header: "Resource Name",
      cell: item => item.ResourceName
  },
  {
      id: "resourceArn",
      header: "Resource ID",
      cell: item => item.ResourceId,
  },
  {
    id: "billingMode",
    header: "BillingMode",
    cell: item => item.ConfiguredProperties ? item.ConfiguredProperties['BillingMode'] : item.CurrentProperties['BillingMode'],
  },
  {
    id: "rcu",
    header: "Read Capacity Units",
    cell: item =>  item.ConfiguredProperties ? item.ConfiguredProperties['ReadCapacityUnits'] :  item.CurrentProperties['ReadCapacityUnits'],
  },
  {
    id: "wcu",
    header: "Write Capacity Units",
    cell: item => item.ConfiguredProperties ? item.ConfiguredProperties['WriteCapacityUnits'] : item.CurrentProperties['WriteCapacityUnits'],
  }
]

export interface DDBRow {
    AccountIdResourceTypePartitionKey: string;
    ResourceId: string;
    AccountId: string;
    CurrentProperties: any;
    CurrentS3Location: string;
    DefaultCreated: boolean;
    DraftOrLaunchedTimeStamp: string;
    Required: boolean;
    ResourceArn: string;
    ResourceDeleted: boolean;
    ResourceName: string;
    ResourceStatus: string;
    ResourceType: string;
    UpdatedTimeStamp: string;
    SourceAccountId: string;
    SourceAccountName: string;
    PropertiesStatus: string;
    ConfiguredProperties: any;
    LaunchedS3Location: string;
  
  }

export const SUPPORTED_AWS_RESOURCE_TYPES = [
    "SQS",
    "SNS",
    "KMS",
    "DYNAMO_DB",
    "IAM_USER",
    "IAM_ROLE",
    "IAM_POLICY",
    "S3"
]

  export const getSelectedResources = (resourceData, pipeline) => {
    if(resourceData) {
      return resourceData.filter(resourceData => resourceData.Required === true  && ( !resourceData.PipelineName || pipeline === resourceData.PipelineName) && resourceData.ResourceDeleted === false)
    }
    return []
  };

  export const AWS_RESOURCE_TYPE = {
    SNS: {
        type: "SNS",
        key: "AWS::SNS::Topic",
        name: "SNS"
    },
    SQS: {
        type: "SQS",
        key: "AWS::SQS::Queue",
        name: "SQS"
    },
    KMS: {
        type: "KMS",
        key: "AWS::KMS::Key",
        name: "KMS"
    },
    DYNAMO_DB: {
      type: "DYNAMO_DB",
      key: "AWS::DynamoDB::Table",
      name: "DynamoDB"
    },
    IAM_USER: {
      type: "IAM_USER",
      key: "AWS::IAM::User",
      name: "IAM User"
    },
    IAM_ROLE: {
      type: "IAM_ROLE",
      key: "AWS::IAM::Role",
      name: "IAM Role"
    }, 
    IAM_POLICY: {
      type: "IAM_POLICY",
      key: "AWS::IAM::Policy",
      name: "IAM Policy"
    },
    S3: {
      type: "S3",
      key: "AWS::S3::Bucket",
      name: "S3"
    }
  }

  export const getResourceKey = (resourceType) => {
    return AWS_RESOURCE_TYPE[resourceType].key;
  }

  export const getResourceName = (resourceType) => {
    return AWS_RESOURCE_TYPE[resourceType].name;
  }

  export const getResourceType = (resourceType) => {
    return AWS_RESOURCE_TYPE[resourceType].type;
  }